import { memoizeWith } from 'ramda';
import { mergeStyles } from '../../../../internal/utils/mergeStyles';
import * as mainStyles from './styles.module.css';
import { getDeviceStyles, getDeviceStylesIdentity } from './device';
function getSwitchStyles(deviceType) {
  var deviceStyles = getDeviceStyles(deviceType);
  return mergeStyles(mainStyles, deviceStyles);
}
export var getStyles = memoizeWith(getDeviceStylesIdentity, getSwitchStyles);